import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import {Box, Button, Divider, IconButton, Stack, TextField, Typography} from "@mui/material";
import CustomTextInput from "../../components/CustomTextInput";
import CloseIcon from "@mui/icons-material/Close";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {PrepaymentValidation} from "../../validations/PrepaymentValidation";
import React, {useEffect, useRef} from "react";
import dayjs from "dayjs";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '500px',
    bgcolor: 'background.paper',
    borderRadius: '15px',
    boxShadow: 24,
};

const emptyDefaults = {
    prepaid_amount: '',
    invoice_number: '',
    invoice_uuid: '',
};

export default function PrepaymentDetailsModal({
                                                   open,
                                                   onClose,
                                                   readOnly = false,
                                                   currentNetAmount = 0,
                                                   initialValue,
                                                   addPrepaidAmount,
                                                   addPrepaymentDetails
                                               }) {
    const mergedInitial = {
        ...emptyDefaults,
        ...(initialValue || {}),
    };

    const initialValueRef = useRef(mergedInitial);
    initialValueRef.current = mergedInitial;

    const {
        handleSubmit: handlePopupSubmit,
        control: popupControl,
        reset: resetPopupForm,
        formState: {errors: popupErrors},
    } = useForm({
        defaultValues: mergedInitial,
        resolver: yupResolver(PrepaymentValidation(currentNetAmount)),
    });

    useEffect(() => {
        if (!open) return;
        resetPopupForm({
            ...emptyDefaults,
            ...(initialValueRef.current || {}),
        });
    }, [open, resetPopupForm]);

    const handleFormSubmit = (data) => {
        addPrepaidAmount?.(data.prepaid_amount);
        const prePaymentData = {
            invoice_number: data?.invoice_number,
            invoice_uuid: data?.invoice_uuid,
        };
        Object.keys(prePaymentData).forEach((key) => {
            if (!prePaymentData[key]) {
                delete prePaymentData[key];
            }
        });
        addPrepaymentDetails?.(prePaymentData);

        onClose();
    };

    return (
        <Modal
            open={open}
            onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                    onClose();
                }
            }}
            className={'backdrop-model'}
        >
            <Fade in={open}>
                <Box sx={style}>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            px: 2,
                            py: 2,
                            borderBottom: '1px solid #e0e0e0',
                        }}
                    >
                        <Typography variant="h6">Pre Payment</Typography>
                        <IconButton onClick={onClose}>
                            <CloseIcon/>
                        </IconButton>
                    </Box>
                    <Divider/>
                    <Box sx={{p: 2}}>
                        <Stack spacing={2}>
                            <CustomTextInput
                                name="prepaid_amount"
                                label="Prepaid Amount"
                                control={popupControl}
                                errors={popupErrors}
                                readOnly={readOnly}
                            />
                            <CustomTextInput
                                name={'invoice_number'}
                                label={'Invoice Number'}
                                control={popupControl}
                                errors={popupErrors}
                                readOnly={readOnly}
                            />
                            <CustomTextInput
                                name={'invoice_uuid'}
                                label={'Invoice UUID'}
                                control={popupControl}
                                errors={popupErrors}
                                readOnly={readOnly}
                            />
                        </Stack>
                    </Box>
                    <Divider/>
                    <Box
                        sx={{
                            px: 2,
                            py: 1,
                            borderTop: '1px solid #e0e0e0',
                            display: 'flex',
                            justifyContent: 'flex-end',
                            gap: 1,
                        }}
                    >
                        <Button
                            id="add-pre-payment"
                            type="button"
                            variant="contained"
                            color="primary"
                            onClick={
                                readOnly
                                    ? onClose
                                    : handlePopupSubmit(handleFormSubmit)
                            }
                        >
                            {readOnly ? "Done" : "Add Pre Payment"}
                        </Button>
                    </Box>
                </Box>
            </Fade>
        </Modal>
    );
}